document.addEventListener("DOMContentLoaded", () => {

  function filterImages() {

    const selectedVariant =
      document.querySelector('input[type="radio"]:checked') ||
      document.querySelector('select[name^="options"]');

    if (!selectedVariant) return;

    const variantName = selectedVariant.value.trim().toLowerCase();

    // 🔥 DAWN MEDIA ITEMS
    const slides = document.querySelectorAll('[data-media-id]');
    if (!slides.length) return;

    slides.forEach(slide => {

      const img =
        slide.querySelector('img') ||
        slide.querySelector('picture img');

      if (!img) return;

      const altText = (img.alt || "").trim().toLowerCase();

      if (altText === variantName || altText.includes("size chart")) {

        slide.style.display = "";
        slide.style.height = "";
        slide.style.pointerEvents = "";

      } else {

        slide.style.display = "none";
        slide.style.height = "0px";
        slide.style.pointerEvents = "none";

      }

    });

    // 🔥 THUMBNAILS
    const thumbs = document.querySelectorAll('[data-target]');

    thumbs.forEach(thumb => {

      const img = thumb.querySelector('img');
      if (!img) return;

      const altText = (img.alt || "").trim().toLowerCase();

      if (altText === variantName || altText === "size chart") {

        thumb.style.display = "";

      } else {

        thumb.style.display = "none";

      }

    });

  }

  function runFilterMultipleTimes() {

    let count = 0;

    const interval = setInterval(() => {

      filterImages();
      count++;

      if (count > 30) {
        clearInterval(interval);
      }

    }, 100);

  }

  // 🔥 INITIAL LOAD
  runFilterMultipleTimes();

  // 🔥 Force Dawn to initialize gallery using current variant
  setTimeout(() => {

    const selectedVariant =
      document.querySelector('input[type="radio"]:checked') ||
      document.querySelector('select[name^="options"]');

    if (selectedVariant) {

      selectedVariant.dispatchEvent(
        new Event("change", { bubbles: true })
      );

    }

  }, 0);

  // 🔥 ON VARIANT CHANGE
  document.addEventListener("change", (e) => {

    if (e.target.matches('input[type="radio"], select[name^="options"]')) {

      runFilterMultipleTimes();

    }

  });

});